import { combineReducers } from 'redux';

import { listReducer, itemReducer } from 'src/reducers/common';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';

export const REDUCER_NAME = 'semiMonthlyPayment';

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
